import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import VueSlider from "vue-slider-component";
import DatePicker from "vue2-datepicker";
import "vue-slider-component/theme/default.css";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from "vuex";
import LightBox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { required, maxLength, numeric, minValue, maxValue } from "vuelidate/lib/validators";

export default {
    name: "contentUpload",
    components: {
        MainLayout,
        StarRating,
        Pagination,
        DatePicker,
        VueSlider,
        AdvancedLaravelVuePaginate,
        Loading,
        LightBox,
    },

    data() {
        return {
            files1: [],
            files2: [],
            totalFiles: 0,
            fileUpload: null,
            filePreview: null,
            file: null,
            uploadFailed: [],
            isLoading: false,
            images : [],
            contentInfo: [],
            groupName: [],
            course_id: 0,
            group_id: 0,
            submitted: false,
            upload: false,
            validation: false,
            msg: "",
            validationMsg: "",
            originalLength: 0,
            content_title: "",
            content_order: "",
            maxSize: 1.5 * 1024 * 1024 * 1024,
            allowFileTypes: ['.xls', '.xlsx', '.pdf', '.doc', '.docx', '.txt', '.ppt', '.pptx', '.jpg', '.jpeg', '.png'],
            videoFileTypes: ['.mov', '.mp4', '.avi', '.wmv', '.avchd', '.webm', '.flv']
            // content_details: "",
            // editor: ClassicEditor,
            // editorConfig: {
            //     toolbar: [
            //         "heading",
            //         "|",
            //         "bold",
            //         "italic",
            //         "bulletedList",
            //         "numberedList"
            //     ]
            // }
        }
    },
    validations: {
        content_title: {
            required,
            maxLength: maxLength(100)
        },
        content_order: {
            numeric,
            minValue: minValue(1),
            maxValue: maxValue(10000),
            notStartWithZero(value) {
                if (!value) return true;
                return !/^0\d+/.test(value);
            }
        },
        // content_details: {
        //     maxLength: maxLength(5000)
        // },
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
        allowedFileTypes() {
            const enableVideoUpload = this.$store.state.user.enable_video_upload;
            if (enableVideoUpload){
                return [...this.allowFileTypes, ...this.videoFileTypes].join(',');
            } else {
                return this.allowFileTypes;
            }
        },
    },

    methods: {
        openFileInput() {
            this.$refs.files.click();
        },

        onClick() { 
            if(this.submitted == true) {
                this.isLoading = true;
            }            
        },
        getContentGroup() {
            axios.get("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id  )
                .then((response) => {
                    this.contentInfo = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },

        triggerFileInput() {
          this.$refs.files.click();
        },

        stopPropagation(event) {
          event.stopPropagation();
        },

        filesChange(uploadedFiles){
            this.images = [];
            this.fileUpload.files = uploadedFiles;
            this.totalFiles = this.fileUpload.files.length;
            const allowedExtensions = ['xls','xlsx','mov','mp4','avi','wmv','avchd','webm','flv','pdf','doc','docx','txt','ppt','pptx','jpg','jpeg','png'];
            const dt = new DataTransfer();
            const input = document.getElementById('files');
            const { files } = input;
            for (let i = 0; i < this.totalFiles; i++) {
                const fileExtension = this.getFileExtension(this.fileUpload.files[i].name);
                if (!allowedExtensions.includes(fileExtension)) {
                    alert(this.fileUpload.files[i].name + " is Invalid file type!");                  
                    this.fileUpload.files[i].value = "";                        
                } else {
                    const file = files[i];
                    dt.items.add(file);

                    let fileSource = this.fileUpload.files[i] ? URL.createObjectURL(this.fileUpload.files[i]) : "";
        
                    this.images.push({ name: this.fileUpload.files[i].name, url: fileExtension, failed: "", fileSource });
                }
                const fileSize = files[0].size;
                const maxGBSize = (this.maxSize / 1024 / 1024 / 1024);
                if (fileSize > this.maxSize) {
                    this.images[i].failed = 2;
                    this.images[i].errorMsg = "The uploaded file size should not exceed "+ maxGBSize+ "GB";
                }
            }
            input.files = dt.files;
            this.totalFiles = input.files.length;
        },

        getFileExtension(filename) {
            return filename.split('.').pop().toLowerCase();
        },

        removeClone(i) {
            var index = this.images.indexOf(this.images[i]);
            this.images.splice(index, 1);

            const dt = new DataTransfer();
            const input = document.getElementById('files');
            const { files } = input;

            for (let j = 0; j < files.length; j++) {
                const file = files[j];
                if (i !== j)
                dt.items.add(file);
            }
            input.files = dt.files;
            this.totalFiles = input.files.length;
            if(this.totalFiles == 0) {
                this.submitted = false;
                this.upload = true;
            }
        },

        submitFile(){
            this.submitted = true;
            this.upload = false;
            this.uploadFailed = [];
            this.uploadCount = [];
            this.isLoading = true;  
            this.uploadSuccess = [];  
            this.upload = [];
            this.files = this.$refs.files.files;
            this.originalLength = this.files.length;
            if(this.files.length <= 0) {
                this.msg = "Please Upload File";
            }  
            if (this.$v.$invalid) {
                this.isLoading = false;
                this.submitted = false;
                this.validation = true;
                return;
            }
            
            if(this.files.length <= 0) {
                this.isLoading = false;
                this.submitted = false;
                return;
            }
            for( let i = 0; i < this.files.length; i++ ){
                if (this.$refs.files.files[i].size > this.maxSize) {
                    this.isLoading = false;
                    this.submitted = false;
                    return;
                }
                const o_fileName = this.$refs.files.files[i].name;                
                let count = i + 1;                                     
                this.file = this.$refs.files.files[i];
                this.upload.push(this.file);

                if(this.$refs.files.files[i].size > 0) {
                    let formData = new FormData();
                    formData.append('file', this.$refs.files.files[i]);
                    formData.append('content_title', this.content_title);
                    formData.append('content_order', this.content_order);
                    axios.post("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/create",
                        formData,
                        {
                        headers: {
                            'Content-Type': 'multipart/form-data;boundary=' + Math.random().toString().substr(2),
                        }
                    }
                    ).then((response) => {
                        this.uploadCount.push(count);   
                        const index1 = this.uploadCount.indexOf(count);
                        if(response.data.status == 'failed') {
                            // const index = this.images.indexOf(this.images[i]);
                            this.uploadFailed.push({ name: this.file.name, index: i });
                            this.images[index1].failed = 2;
                        } else {
                            this.uploadSuccess.push({ name: o_fileName });
                            for (let k = 0; k < this.images.length; k++) {  // remove preview data   
                                if(o_fileName == this.images[k].name) {
                                    this.images.splice(k, 1);
                                }
                            }
                            if (index1 > -1) { // only splice array when item is found                           
                                this.uploadCount.splice(index1, 1);
                                // this.uploadSuccess.splice(index1, 1);
                            }
                            const dt = new DataTransfer();
                            const input = document.getElementById('files');
                            const { files } = input;

                            for (let j = 0; j < files.length; j++) {          
                                const file = files[j];
                                if (index1 !== j)
                                dt.items.add(file);
                            }
                            input.files = dt.files;
                            this.totalFiles = input.files.length;
                        }
                    

                        if(this.uploadFailed.length == this.originalLength) {
                            this.isLoading = false;
                            this.submitted = false;
                            this.upload = true; 
                            this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                                timer: 3,
                                position: "bottomCenter"
                            });
                        } if(this.uploadSuccess.length == this.originalLength) { // totally success
                            localStorage.setItem('reloaded', 'true');
                            this.$router.push({
                                name: "contentList",
                                params: this.$route.params.id
                            });
                        } else if(this.upload.length == this.originalLength) {
                            if(this.originalLength - this.uploadSuccess.length == this.uploadFailed.length) {
                                this.isLoading = false;
                                this.submitted = false;
                                this.upload = true;
                            }
                        }            
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 422 ) {
                            const errors = error.response.data.errors;
                            const msg = errors.file?.[0];
                            this.images[i].failed = 2;
                            this.images[i].errorMsg = msg;
                        }
                        if (error.response.status == 401) {
                            this.$store.commit('logout');
                            window.location.replace('/');
                        }
                        if (error.response.status == 403) {
                            this.$router.push({
                                name: 'forbidden'
                            });                     
                        }
                        this.uploadFailed.push({ name: this.file.name, index: i });
                        this.uploadCount.push(count);   
                        const index1 = this.uploadCount.indexOf(count);
                        this.images[index1].failed = 2;
                        if(this.uploadFailed == this.originalLength) {
                            this.isLoading = false;
                            this.submitted = false;
                            this.upload = true;
                            this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                                timer: 3,
                                position: "bottomCenter"
                            });
                        } else if(this.upload.length == this.originalLength) {
                            if(this.originalLength - this.uploadSuccess.length == this.uploadFailed.length) {
                                this.isLoading = false;
                                this.submitted = false;
                                this.upload = true;
                            }
                        }     
                    });
                } else {
                    this.uploadCount.push(count);   
                    const index1 = this.uploadCount.indexOf(count);
                    this.uploadFailed.push({ name: this.file.name, index: i });
                    this.images[index1].failed = 3;
                    if(this.uploadFailed == this.originalLength) {
                        this.isLoading = false;
                        this.submitted = false;
                        this.upload = true;
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else if(this.upload.length == this.originalLength) {
                        if(this.originalLength - this.uploadSuccess.length == this.uploadFailed.length) {
                            this.isLoading = false;
                            this.submitted = false;
                            this.upload = true;
                        }
                    }     
                }                
            }
        },

        getVideoUpload() {
            axios.get('/video-file/video')
                .then((response) => {
                    this.videos = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Student Detail API Error", error);
                });
        },

        downloadPdfForStudentInfo() {
            let filename = '5UTq4CO9txP7nCpMhe4TEPqKD7gxtZl7GLyOzsxa.pdf.enc';
            axios.get("/video-file/download/" + filename, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                responseType: 'blob' // responseType is a sibling of headers, not a child
                })
                .then(response => {
                if (response.status == 200) {
                    const fileName = `video.pdf`;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                })
                .catch(error => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });                        
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                })
            },            
    },

    mounted() {     
        // this.getVideoUpload();
        document.addEventListener('click', this.onClick);
        this.getContentGroup();
        this.fileUpload = document.getElementById('files');
        this.filePreview = document.getElementById('file_preview');
    }
};
